import { gql } from "@apollo/client";
import { useCallback } from "react";
import { useQuery } from "@apollo/client/react";

import type { Restaurants } from "../../types/restaurantTypes";
import type { UseOptions } from "../hookTypes"
import { ADDRESS_FRAGMENT } from "../../fragments/address";

const GET_RESTAURANTS = gql`
  query Restaurants {
    restaurants {
      id
      name
      phone
      website
      wifi
      img {
        small
        medium
      }
      address {
        ...AddressFragment
      }
    }
  }
  ${ADDRESS_FRAGMENT}
`; 

const useRestaurants = (options?: UseOptions) => {
  const { fetchPolicy = "cache-and-network", refetchOnMount = false } = options ?? {};

  const { data, loading, error, refetch } = useQuery<Restaurants>(GET_RESTAURANTS, {
    fetchPolicy,
    notifyOnNetworkStatusChange: true,
  });

  if (refetchOnMount && !loading) {
    refetch();
  }

  const restaurants = data?.restaurants;

  const refetchRestaurants = useCallback(async () => {
    try {
      await refetch();
    } catch {
      // log if need
    }
  }, [refetch]);

  return {
    restaurants,
    loading,
    error: error as Error | null | undefined,
    refetchRestaurants,
  };
}

export default useRestaurants
